module.exports = __webpack_public_path__ + "img/flag-checkered-solid.ad758f7b.svg";